import React from 'react';

const ImpactAnalysisTabContext = React.createContext({});

export default ImpactAnalysisTabContext;
